import { httpGetContent } from '../../http';
import { ISearchPageItemDto, ISearchPagesDto } from '../types';

async function getPages(pageIds: string[]): Promise<ISearchPageItemDto[]> {
    const items = await httpGetContent<ISearchPagesDto>('articles', 'GetItems', { pages: pageIds.join(',') });

    return items.Pages ?? [];
}

export { getPages };
